module.exports = __webpack_public_path__ + "img/dr01.4d1158ac.png";